document.addEventListener('DOMContentLoaded', function () {
  const giftSaveButton = document.querySelector('#cart-gift-box-save-btn');

  // Event listener for checkbox change
  $(document).on('change', '.gifting-option-checkbox-input', function (event) {
    const el = $(event.target);
    const parents = el.parents('.cart-gift-drawer-items');
    const errorContainer = document.querySelector('#gift-drawer-error-message');

    if (el.prop('checked') === true) {
      parents.attr('data-item-cart-action', 'add');
    } else {
      parents.attr('data-item-cart-action', 'remove');
    }

    // Undoes the disabled state that is added when gift box quantity is invalid
    errorContainer.style.display = 'none';
    giftSaveButton.removeAttribute('disabled');
  });

  // Event listener for textarea
  $(document).on('change', '.cart-gifting-drawer-textarea', function (event) {
    const el = $(event.target);
    const parents = el.parents('.cart-gift-drawer-items');

    parents.attr('data-item-cart-action', 'add');
  });

  closeDrawer = () => {
    const cartGiftOptionDrawer = document.querySelector('cart-gift-option-drawer');
    cartGiftOptionDrawer.classList.remove('open');
    document.body.classList.remove('overflow-hidden--drawer-open');
    document.documentElement.classList.remove('overflow-hidden--drawer-open');
  };

  if (giftSaveButton) {
    giftSaveButton.addEventListener('click', function (event) {
      const dataObject = [];
      const $clickedElement = $(event.target);

      if ($clickedElement.attr('type') == 'submit') {
        // Check that the desired gift box quantity is valid.
        if (!isGiftBoxQuantityValid()) {
          const errorContainer = document.querySelector('#gift-drawer-error-message');

          errorContainer.style.display = 'block';
          errorContainer.innerHTML = window.giftingStrings.outOfStockError;
          giftSaveButton.setAttribute('disabled', 'disabled');
          return;
        }

        const drawerWrap = $clickedElement.parents('.cart-gift-option-drawer');
        const timestampItemKeyMap = {};

        /**
         * Store a count value that gets incremented in each loop.
         * - Helps ensures that the groupId is unique when multiple edits are
         *   triggered at once.
         */
        let count = 0;
        drawerWrap.find('.cart-gift-drawer-items').each(function () {
          const actionType = $(this).attr('data-item-cart-action');
          const itemKey = $(this).attr('data-itemkey');
          const parentId = $(this).attr('data-id');
          const groupId = $(this).attr('data-group-id');
          const quantity = $(this).attr('data-line-quantity');
          const isAddon = $(this).attr('data-is-addon') === 'true';
          const addonType = $(this).attr('data-addon-type');

          /**
           * Get item properties as an object.
           * - Retrieve properties from data attribute.
           * - Parse string to JSON
           * - Convert JSON array of key pair values into an object using
           *   `Object.fromEntries`
           * - Existing properties object is used to ensure existing non-gift
           *   properties remain on the product after updates.
           */
          const existingPropertiesAttribute = $(this).attr('data-properties');
          const existingPropertiesJSON = JSON.parse(existingPropertiesAttribute);
          const existingProperties = Object.fromEntries(existingPropertiesJSON);

          if (actionType != 'added') {
            if ($(this).find('input').is(':checked')) {
              // Date attribute for gift box row
              const giftId = $(this).attr('data-gift-box-id');

              const mainProductTitle = $(this).attr('data-title');
              const giftBoxExist = $(this).attr('data-gift-item-exist');
              const noteDiv = $(this).find('.gifting-drawer-textarea-box textarea');
              const noteValue = noteDiv.val();

              const dateNow = Date.now();
              const newGroupId = groupId || dateNow + count * 1000;
              count++;

              // Form data for main product
              const mainProductLine = {
                id: itemKey,
                quantity: quantity,
                properties: {
                  ...existingProperties,
                  Note: noteValue,
                  _hasGiftBox: true,
                  _giftboxId: giftId,
                  _groupId: newGroupId,
                },
              };

              // Form data for gift box product
              const giftProductLine = {
                id: giftId,
                quantity: quantity,
                properties: {
                  'Gift Box With': mainProductTitle,
                  _parentPid: parentId,
                  _groupId: newGroupId,
                  _addon: true,
                  _addonType: 'Gift Box',
                },
              };

              /**
               * Check if gift box is already added.
               * - If gift box already exists on product, update both lines.
               * - Otherwise updates the main product but adds the gift box
               *   product.
               */
              if (giftBoxExist == 'true') {
                mainProductLine.actionType = 'update';
                giftProductLine.actionType = 'update';
                dataObject.push(mainProductLine, giftProductLine);
              } else {
                // Set action type for main product
                mainProductLine.actionType = 'update';
                // Set action type for giftbox
                giftProductLine.actionType = 'add';
                dataObject.push(mainProductLine, giftProductLine);
              }
            } else if (actionType === 'remove') {
              /**
               * Create payload for main product update when removing a gift box
               * - If the product has personalisation, don't clear the groupId
               *   so that main product and personalisation are still linked.
               */

              const hasPersonalisation = Boolean(existingProperties[window.personalisationStrings?.initialsProperty]);

              const newProperties = {
                ...existingProperties,
                _hasGiftBox: false,
              };

              if (!hasPersonalisation) {
                delete newProperties.groupId;
              }

              delete newProperties.Note;
              delete newProperties._giftboxId;

              const payloadForMainProduct = {
                actionType: 'update',
                id: itemKey,
                quantity,
                properties: newProperties,
              };

              dataObject.push(payloadForMainProduct);

              // By now we should already have a gift to remove
              const giftKey = timestampItemKeyMap[groupId];
              if (giftKey) {
                const payloadForGiftBoxRemove = {
                  actionType: 'update',
                  id: giftKey,
                  quantity: 0,
                };

                dataObject.push(payloadForGiftBoxRemove);
              }
            } else if (groupId && isAddon && addonType === 'Gift Box') {
              timestampItemKeyMap[groupId] = itemKey;
            }
          }
        });

        // Check dataObj length
        if (dataObject.length > 0) {
          // Setting aria label attribute
          $clickedElement.attr('aria-disabled', 'true');

          // Adding loading state
          $clickedElement.addClass('loading');
          $clickedElement.find('.loading__spinner').removeClass('hidden');
          addAllItems(dataObject, $clickedElement);
        } else {
          // Close the drawer
          closeDrawer();
        }
      }
    });
  }

  /**
   * Check if the user's requested gift box stock is valid.
   * - Loops through the gift lines to get the following:
   *   - Whether the product has a linked gift box item
   *   - The current stock of the linked gift box item, added as a data
   *     attribute `data-gift-box-quantity`
   *     - The stock level is set to Infinity if Shopify is not tracking stock,
   *       grabbed from a data attribute `data-gift-box-check-quantity`
   *   - The desired stock, calculated from the main product's quantity and
   *     whether the user is adding or updating a gift box, based on the
   *     `data-item-cart-action` attribute
   * - Then compares the desired stock against the inventory stock to make sure
   *   that for every gift box variant id the desired quantity is less that or\
   *   equal to the available stock
   * @returns {Boolean} whether requested gift box stock amount is valid
   */
  function isGiftBoxQuantityValid() {
    const drawerElement = document.querySelector('.cart-gift-option-drawer');
    const lineItems = drawerElement.querySelectorAll('.cart-gift-drawer-items');

    // Set up objects to store desired and requested quantities.
    const giftBoxInventoryQuantity = {};
    const giftBoxDesiredQuantity = {};

    lineItems.forEach((lineItem) => {
      const linkedGiftBoxId = lineItem.dataset.giftBoxId;
      const linkedGiftBoxQuantity = lineItem.dataset.giftBoxQuantity;
      const linkedGiftBoxCheckQuantity = lineItem.dataset.giftBoxCheckQuantity === 'true';

      if (!linkedGiftBoxId) {
        return;
      }

      giftBoxInventoryQuantity[linkedGiftBoxId] = linkedGiftBoxCheckQuantity ? Number(linkedGiftBoxQuantity) : Infinity;

      const itemQuantity = Number(lineItem.dataset.lineQuantity);
      const giftAdded = ['add', 'added'].includes(lineItem.dataset.itemCartAction);
      const desiredQuantity = giftAdded ? itemQuantity : 0;

      giftBoxDesiredQuantity[linkedGiftBoxId] = giftBoxDesiredQuantity[linkedGiftBoxId]
        ? giftBoxDesiredQuantity[linkedGiftBoxId] + desiredQuantity
        : desiredQuantity;
    });

    const isQuantityValid = Object.keys(giftBoxDesiredQuantity).every((key) => {
      return giftBoxDesiredQuantity[key] <= giftBoxInventoryQuantity[key];
    });

    return isQuantityValid;
  }

  // Add to cart ajax for gift box products
  async function addAllItems(dataItems, $this) {
    /**
     * Sort cart updates to make sure that the `add` actions happen at the end.
     * - Prevents an issue the user is adding a gift box to one product and
     *   removing a gift box from another.
     *   - In this situation, if all the gift boxes are accounted for with stock
     *     and the Add fired first, there would be an error to say that theres
     *     not enough stock on the gift boxes.
     *   - By moving the `add` cart action to the end of the array we are
     *     ensuring we "free up" the stock for the add event later.
     */
    const sortedCartUpdates = [...dataItems].sort((a, b) => {
      if (a.actionType === b.actionType) return 0;
      if (a.actionType === 'add') return 1;
      if (b.actionType === 'add') return -1;
    });

    for (let data of sortedCartUpdates) {
      const actionType = data.actionType;
      const url = actionType === 'add' ? routes.cart_add_url : routes.cart_change_url;

      try {
        await fetch(url, {
          ...fetchConfig(),
          body: JSON.stringify(data),
        });
      } catch (error) {
        console.log(error);
      }
    }

    // Reloading cart drawer contents and cart bubble in header.
    updateCart();

    // Setting aria label attribute
    $this.attr('aria-disabled', 'false');

    // Adding loading state
    $this.removeClass('loading');
    $this.find('.loading__spinner').addClass('hidden');

    closeDrawer();
  }

  /**
   * Fetch the latest cart state and update sections.
   * - Fetches the latest cart state and then updates the cart sections to show
   *   the new data.
   */
  function updateCart() {
    fetch(`${routes.cart_url}?sections=${getSectionsToRender().map((section) => section.section)}`)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = getSectionInnerHTML(parsedState[section.section], section.selector);
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // Function to check if the gift box or message has been added
  function checkGiftBoxSelection() {
    const giftBoxContent = document.querySelector('#selected-gift-box').textContent.trim();
    const giftMessage = document.querySelector('#gift-message').value.trim();
    const giftBox = document.getElementById('gift-box').checked;
    const giftBoxVariantInput = document.querySelector('#gift-box-variant-id');
    const isGiftBoxAdded = document.querySelector('#gift-box-for-product');
    const selectedGiftMessage = document.querySelector('#selected-gift-message');
    const mainVariantId = document.querySelector('#main__variantId');
    const giftVariantId = document.querySelector('#gift__variantId');
    const hasGiftBoxId = document.querySelector('#hasgiftboxId');
    const mainProductGroupId = document.querySelector('#main-product-groupId');
    const giftProductGroupId = document.querySelector('#gift-box-groupId');
    const giftProductAddon = document.querySelector('#gift-box-addon');
    const giftProductAddonType = document.querySelector('#gift-box-addon-type');

    updateGiftGroupIdInputs();

    if (giftBoxContent && giftBox) {
      giftBoxVariantInput.disabled = false;
      isGiftBoxAdded.disabled = false;
      selectedGiftMessage.disabled = false;
      mainVariantId.disabled = false;
      giftVariantId.disabled = false;
      hasGiftBoxId.disabled = false;
      mainProductGroupId.disabled = false;
      giftProductGroupId.disabled = false;
      giftProductAddon.disabled = false;
      giftProductAddonType.disabled = false;
    } else {
      giftBoxVariantInput.disabled = true;
      isGiftBoxAdded.disabled = true;
      selectedGiftMessage.disabled = true;
      mainVariantId.disabled = true;
      giftVariantId.disabled = true;
      hasGiftBoxId.disabled = true;
      mainProductGroupId.disabled = true;
      giftProductGroupId.disabled = true;
      giftProductAddon.disabled = true;
      giftProductAddonType.disabled = true;
    }

    if (giftMessage) {
      selectedGiftMessage.disabled = false;
    } else {
      selectedGiftMessage.disabled = true;
    }
  }

  /**
   * Update the Group ID hidden inputs with a new timestamp to ensure the group
   * id is always unique.
   */
  function updateGiftGroupIdInputs() {
    const timestamp = Date.now().toString();
    const mainProductGroupId = document.querySelector('#main-product-groupId');
    const giftProductGroupId = document.querySelector('#gift-box-groupId');

    if (mainProductGroupId) {
      mainProductGroupId.value = timestamp;
    }

    if (giftProductGroupId) {
      giftProductGroupId.value = timestamp;
    }
  }

  // Update the hidden input field when the user confirms their gift box selection
  const confirmGifting = document.querySelector('#confirm-gifting');

  if (confirmGifting) {
    confirmGifting.addEventListener('click', function () {
      checkGiftBoxSelection();
    });

    /**
     * Update Group ID inputs on variant change.
     */
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      updateGiftGroupIdInputs();
    });
  }

  // Initial check on page load
  const giftBoxInput = document.querySelector('#selected-gift-box');

  if (giftBoxInput) {
    checkGiftBoxSelection();
  }
});
